import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ServerUrl from "../../../../BACKEND";
import typeImages from "./TypeImages";
import { useLanguage } from "../../../Authentication/LanguageContext";
import "./A1Basic.css";

interface A1Part {
  id: number;
  german: string;
  english: string;
  tamil: string;
  sinhala: string;
  hindi: string;
  arabic: string;
  turkish: string;
  russian: string;
  chinese: string;
  french: string;
  spanish: string;
  [key: string]: any;
}

const A1Basic: React.FC = () => {
  const [data, setData] = useState<A1Part[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => {
    const fetchA1Data = async () => {
      try {
        const response = await fetch(`${ServerUrl}/api/a1parts`);
        const json = await response.json();
        setData(json);
      } catch (error) {
        console.error("Error fetching A1 data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchA1Data();
  }, []);

  const groupedData = data.reduce((acc: Record<string, A1Part[]>, item) => {
    if (!acc[item.german]) acc[item.german] = [];
    acc[item.german].push(item);
    return acc;
  }, {});

  const handleClick = (german: string) => {
    const routeMap: Record<string, string> = {
      Alphabet: "/levels/a1/basic/alphabet",
      Zahlen: "/levels/a1/basic/numbers",
      Farben: "/levels/a1/basic/colors",
      Tiere: "/levels/a1/basic/animals",
      Vögel: "/levels/a1/basic/birds",
      Körperteile: "/levels/a1/basic/body",
      Kleidung: "/levels/a1/basic/cloths",
      Tage: "/levels/a1/basic/days",
      Richtungen: "/levels/a1/basic/direction",
      Getränke: "/levels/a1/basic/drinks",
      Gefühle: "/levels/a1/basic/emotion",
      Familie: "/levels/a1/basic/family",
      Essen: "/levels/a1/basic/food",
      Obst: "/levels/a1/basic/fruits",
      Gemüse: "/levels/a1/basic/vegetables",
      Möbel: "/levels/a1/basic/furnitures",
      Hobbys: "/levels/a1/basic/hobbies",
      Monate: "/levels/a1/basic/months",
      Berufe: "/levels/a1/basic/profession",
      Jahreszeiten: "/levels/a1/basic/seasons",
      Sport: "/levels/a1/basic/sports",
      Uhrzeit: "/levels/a1/basic/time",
      Verkehr: "/levels/a1/basic/transport",
      Wetter: "/levels/a1/basic/weather",
    };

    const route = routeMap[german];
    if (route) {
      navigate(route);
    } else {
      alert(`${german} is coming soon!`);
    }
  };

  const getTranslation = (item: A1Part) => {
    const languageMap: Record<string, string> = {
      en: "english",
      de: "german",
      ta: "tamil",
      si: "sinhala",
      hi: "hindi",
      ar: "arabic",
      tr: "turkish",
      ru: "russian",
      zh: "chinese",
      fr: "french",
      es: "spanish",
    };

    const translationField = languageMap[language];
    return translationField && item[translationField]
      ? item[translationField]
      : item.german;
  };

  const translations = {
    title: {
      en: "Grundlagen",
      de: "Grundlagen",
      ta: "அடிப்படைகள்",
      si: "මූලික කරුණු",
      hi: "मूल बातें",
      ar: "أساسيات",
      tr: "Temeller",
      ru: "Основы",
      zh: "基础",
      fr: "Bases",
      es: "Fundamentos",
    },
    subtitle: {
      en: "Basic",
      de: "Grundlegend",
      ta: "அடிப்படை",
      si: "මූලික",
      hi: "बुनियादी",
      ar: "أساسي",
      tr: "Temel",
      ru: "Базовый",
      zh: "基本的",
      fr: "De base",
      es: "Básico",
    },
  };

  return (
    <div className="a1basic-wrapper">
      <div className="a1basic-header">
        <h1 className="a1basic-title">Grundlagen</h1>
        <p className="a1basic-subtitle">{translations.subtitle[language]}</p>
      </div>

      {loading ? (
        <div className="a1basic-loading">Loading...</div>
      ) : (
        <div className="a1basic-grid-container">
          <div className="a1basic-grid">
            {Object.entries(groupedData).map(([german, items]) => (
              <div
                key={german}
                className="a1basic-card"
                onClick={() => handleClick(german)}
              >
                <img
                  src={typeImages[german] || ""}
                  alt={german}
                  className="a1basic-image"
                />
                <div className="a1basic-texts">
                  <h3>{german}</h3>
                  <p>{getTranslation(items[0])}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default A1Basic;